/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Bind from 'lodash-decorators/bind';
import styled from 'styled-components';
import ds from 'designsystem';
import Arrow from 'blocks/Arrow/Arrow';
import CloseIcon from 'blocks/CloseIcon';
import { inject, observer } from 'mobx-react';
import { KEY_FRAMES } from 'animations/Animations';

export const ValueListBoxWrapper = styled.div`
  position: relative;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.bold')};
  background-color: ${ds.brand('white')};
`;

export const ValueListBoxSelect = styled.div`
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.bold')};
  width: 100%;
  padding: calc(${ds.get('metrics.xs')} / 2) 0;
  border: none;
  background-color: ${ds.brand('white')};
  border-bottom: 1px solid ${ds.brand('background')};
  user-select: none;
  transition: 0.2s;
  cursor: pointer;
  
  ${({ optionsVisible }) => (optionsVisible ? 'border-bottom: 1px solid transparent;' : '')}
`;

export const ValueListBoxOptionsWrapper = styled.div`
  ${({ visible }) => (visible ? 'opacity: 1; height: auto' : 'opacity: 0; height: 0')};

  background-color: ${ds.brand('white')};
  position: absolute;
  width: 100%;
  overflow-y: auto;
  border-radius: 2px;
  transition-duration: 0.2s;
`;

export const ValueListBoxOption = styled.div`
  position: relative;
  padding: calc(${ds.get('metrics.xs')} / 1.5) 0;
  font-weight: ${ds.get('type.fontWeight.bold')};
  user-select: none;
  transition: 0.2s;
  background-color: ${ds.brand('white')};
      
  &:hover { 
    background-color: ${ds.brand('background')};
  }
`;

export const ValueListBoxArrow = Arrow.extend`
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
  margin: ${ds.get('metrics.xs')} calc(${ds.get('metrics.xs')} / 6);
  border: 1px solid ${ds.brand('product')};
  border-left: none;
  border-top: none;
  width: calc(${ds.get('metrics.xs')} * 2/3);
  height: calc(${ds.get('metrics.xs')} * 2/3);
  animation: ${KEY_FRAMES.FADE_IN} 0.1s linear;
`;

export const ValueListBoxCloseIcon = CloseIcon.extend`
  position: absolute;
  top: 1px;
  right: 0;
  margin: ${ds.get('metrics.xs')} 0;
  
  &:before, &:after {
    background-color: ${ds.brand('product')};
    height: 16px;
    width: 1px;
    left: 26px;
  }
  animation: ${KEY_FRAMES.FADE_IN} 0.1s linear;
`;

export const ValueListBoxItemCount = styled.span`
  color: ${ds.brand('product')};
  margin-left: calc(${ds.get('metrics.xs')} * 2/3);
`;

export const ValueListBoxOptionFooter = styled.hr`
  position: relative;
  margin: ${ds.get('metrics.s')} 0;
  border: none;
  border-bottom: 1px solid ${ds.brand('background')};
`;

@inject('windowStore')
@observer
export default class ValueListBox extends Component {
  constructor(props) {
    super(props);
    const {
      activeFilter,
      categories,
    } = this.props;

    this.state = {
      value: activeFilter,
      options: categories,
      filteredOptions: categories.filter(option => option.name !== activeFilter.name),
      dropDown: false,
    };

    this.valueListBoxRef = React.createRef();
  }

  componentDidMount() {
    const { windowStore } = this.props;
    this.disposeReaction = windowStore.onClickedAnywhere((event) => {
      const { dropDown } = this.state;
      if (this.valueListBoxRef.current.contains(event.target) || dropDown) {
        this.toggleMenu();
      }
    });
  }

  componentWillUnmount() {
    this.disposeReaction();
  }

  static getDerivedStateFromProps(newProps) {
    const {
      activeFilter,
      categories,
    } = newProps;

    return {
      value: activeFilter,
      options: categories,
      filteredOptions: categories.filter(option => option.name !== activeFilter.name),
    };
  }

  @Bind
  setValue(newValue) {
    const {
      options,
    } = this.state;

    const {
      onSelect,
    } = this.props;

    this.setState({
      value: newValue,
      filteredOptions: options.filter(option => option !== newValue),
    });

    onSelect(newValue.value);
  }

  @Bind
  toggleMenu() {
    const { dropDown } = this.state;
    this.setState({
      dropDown: !dropDown,
    });
  }

  render() {
    const {
      maxWidth,
    } = this.props;
    const {
      value,
      filteredOptions,
      dropDown,
    } = this.state;

    return (
      <ValueListBoxWrapper maxWidth={maxWidth} innerRef={this.valueListBoxRef}>
        <ValueListBoxSelect
          optionsVisible={dropDown}
        >
          {value.name}
          {value.count != null && (
            <ValueListBoxItemCount>
              {` (${value.count})`}
            </ValueListBoxItemCount>
          )}

        </ValueListBoxSelect>

        <ValueListBoxOptionsWrapper visible={dropDown}>
          {filteredOptions.map((option, i) => (
            <ValueListBoxOption
              value={option.value}
              key={option.id || i}
              onClick={() => this.setValue(option)}
            >
              {option.name}
              {option.count != null && (
                <ValueListBoxItemCount>
                  {` (${option.count})`}
                </ValueListBoxItemCount>
              )}
            </ValueListBoxOption>
          ))}
          <ValueListBoxOptionFooter />
        </ValueListBoxOptionsWrapper>

        {dropDown ? <ValueListBoxCloseIcon /> : <ValueListBoxArrow />}

      </ValueListBoxWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/FiltersList/ValueListBox/index.jsx